import api from "./instance";
import { pickData } from "./util";

/**
 * types
 */

export type Backup = {
  id: number;
  title: string;
};

/**
 * Endpoints
 */

export const getAvailableBackups = () =>
  api.get<Backup[]>(`/backup`).then(pickData);

export const restoreBackup = (id: string) => api.post(`/backup/${id}`);
